/**
 * SVG Paths for Flag Component
 *
 * Exported from Figma design to create the 3D parallelogram flag shape.
 * ViewBox: 0 0 724 254
 */

export const flagSvgPaths = {
  // Black shadow layer (outermost)
  shadow:
    'M706.44 229.11L698.44 233.87H17.32V24.26L706.59 19.46L706.44 24.26L647.99 129.07L706.44 229.11Z',

  // Yellow/gold gradient border layer
  border: 'M706.44 229.11H17.32V19.49H706.44L647.99 124.3L706.44 229.11Z',

  // Flag area (used for both white background and flag image clipping)
  flagArea: 'M631.28 124.3L685.48 217.53H23.44V30.47H685.48L631.46 124L631.28 124.3Z'
} as const;

/**
 * Gradient definition for the gold border
 */
export const goldGradientStops = [
  { offset: '0', color: '#FCC10E' },
  { offset: '0.15', color: '#FFF11C' },
  { offset: '0.31', color: '#EDAB16' },
  { offset: '0.61', color: '#F7FE21' },
  { offset: '0.84', color: '#FFD72A' }
] as const;

/**
 * Flag image positioning within the SVG viewBox
 * Coordinates match the flag area bounds from Figma
 */
export const FLAG_IMAGE_BOUNDS = {
  x: 23.44,
  y: 30.47,
  width: 662.04,
  height: 187.06
} as const;

/**
 * CDN image widths optimized per size variant
 * FlagCDN supports: w20, w40, w80, w160, w320, w640, w1280
 * Using 2x resolution for retina display support
 */
export const CDN_IMAGE_WIDTHS = {
  sm: 160, // Small flags: ~80px wide (2x for retina)
  md: 320, // Medium flags: ~128px wide (2x for retina)
  lg: 320 // Large flags: ~192px wide (320px is sufficient at 2x)
} as const;
